import { ref } from 'vue'

interface Notification {
  id: number
  message: string
  type: 'success' | 'error' | 'warning' | 'info'
  duration?: number
  closable?: boolean
}

// Singleton notification state - shared across all instances
let notificationsSingleton: ReturnType<typeof ref<Notification[]>> | null = null
let nextIdGlobal = 0

const initSingleton = () => {
  if (notificationsSingleton === null) {
    notificationsSingleton = ref<Notification[]>([])
  }
  return notificationsSingleton
}

export const useNotifications = () => {
  const notifications = initSingleton()

  const addNotification = (message: string, options: Partial<Notification> = {}) => {
    const notification: Notification = {
      id: nextIdGlobal++,
      message,
      type: 'info',
      duration: 3000,
      closable: true,
      ...options
	  }

    notifications.value!.push(notification)

    if (notification.duration && notification.duration > 0) {
      setTimeout(() => {
        removeNotification(notification.id)
      }, notification.duration)
    }
  }

  const removeNotification = (id: number) => {
    notifications.value = notifications.value!.filter(n => n.id !== id)
  }

  const clearNotifications = () => {
    notifications.value = []
  }

  return {
    notifications,
    addNotification,
    removeNotification,
    clearNotifications
  }
}
